import { useHistory, useLocation } from "react-router-dom";
import useLoginModel from "../useLogin";
import { Button, Input, Spinner } from "@material-tailwind/react";
import { SubmitHandler, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { BASEURL } from "../../../util";
import Logo from "../../../assets/logo.png";

type LoginType = {
  phone: string;
};

export default function LoginOtp() {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { isSubmitting, errors },
  } = useForm<LoginType>();
  const history = useHistory();

  const onSubmit: SubmitHandler<LoginType> = async (data) => {
    if (data?.phone?.trim()?.length < 10) {
      return toast.error("Phone number required");
    }
    try {
      let options = {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(data),
      };

      const req = await fetch(
        `${BASEURL}/request-reset-password-broker`,
        options
      );

      const res = await req.json();

      if (req.ok) {
        if (res?.status === 200) {
          const { data } = res;
          toast.success(
            res?.message ?? "Password reset request sent successfully"
          );
          reset();
          localStorage.setItem("user_id", data?.user_id);
          setTimeout(() => {
            history.push("/change-password");
            window.location.reload();
          }, 1500);
        } else {
          toast.error(res?.data ?? "An error occured");
        }
      } else {
        toast.error(res?.data ?? "An error occured");
      }
    } catch (error: any) {
      toast.error(error?.message);
    }
  };

  return (
    <main className="w-full h-screen bg-white flex items-center justify-center">
      <form onSubmit={handleSubmit(onSubmit)} className="">
        <div className="mb-10 flex items-center justify-center">
          <img src={Logo} alt="logo" className="w-36 object-cover" />
        </div>
        <p className="mb-4 text-grey-700 font-bold">Request OTP</p>

        <div>
          <label
            htmlFor="phone"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Phone number associated with account
          </label>
          <div className="mt-2">
            <Input
              crossOrigin={""}
              id="phone"
              error={!!errors.phone}
              type="text"
              label="Phone number"
              size="lg"
              className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
              {...register("phone", { required: true })}
            />
            {errors.phone && (
              <span className="text-left mt-2 text-xs text-brand-primary">
                Phone is required
              </span>
            )}
          </div>
        </div>

        <div>
          <Button
            variant="gradient"
            size="lg"
            type="submit"
            style={{
              background: "#00308F",
            }}
            className="mt-5 flex items-center justify-center w-full text-sm font-bold leading-none text-white transition duration-300 md:w-96 rounded-2xl hover:bg-purple-blue-600 focus:ring-4 focus:ring-purple-blue-100 bg-purple-blue-500"
          >
            {isSubmitting ? (
              <Spinner className="w-5 h-5 text-white" />
            ) : (
              "Sned OTP"
            )}
          </Button>
        </div>
        <p className="mt-5 text-center text-sm text-gray-500">
          Take me back to?{" "}
          <a href="/" className="font-semibold leading-6 text-[#00308F]">
            Login
          </a>
        </p>
      </form>
    </main>
  );
}
